import styled from 'styled-components';
import { Box } from '@components/Box';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';

export const SectionContainer = styled(Box)<{
  backgroundImage: string;
}>`
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 75%),
    url(${props => cloudAssetUrl(props.backgroundImage, { optimization: 'mild', isResizeDisabled: true })});
  background-blend-mode: multiply, normal;
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  width: 100vw;
  height: 955px;
  display: flex;
  justify-content: center;
`;

export const TextPairingWrapper = styled(Box)`
  padding-top: ${themeSpace(15)};
  max-width: 380px;
  height: max-content;
  ${themeMediaQuery('xl')} {
    max-width: 680px;
  }
`;

export const StyledHeroText = styled(Text)`
  text-align: center;
`;
